import React from 'react';

import PageIcon from '@atlaskit/icon/core/page';
import { Page } from '@atlassian/embedded-confluence';
import {
	PreviewPanel,
	PreviewPanelBody,
	PreviewPanelHeader,
	PreviewPanelTitle,
} from '@atlassian/preview-panel';
import { useGetPreviewPanelsActions } from '@atlassian/preview-panels-api';

export interface ConfluencePagePreviewPanelProps {
	title: string;
	url: string;
}

const ConfluencePagePreviewPanel = ({ title, url }: ConfluencePagePreviewPanelProps) => {
	const { close } = useGetPreviewPanelsActions();

	const onClose = () => {
		close();
	};

	return (
		<PreviewPanel testId="confluence-preview-panel">
			<PreviewPanelHeader onClose={onClose} url={url}>
				<PreviewPanelTitle title={title} Icon={PageIcon} />
			</PreviewPanelHeader>
			<PreviewPanelBody>
				<Page locale="en-US" url={url} />
			</PreviewPanelBody>
		</PreviewPanel>
	);
};

export const useConfluencePagePreviewPanel = (title: string, url: string) => {
	const { open, close } = useGetPreviewPanelsActions();

	const openConfluencePagePreviewPanel = () => {
		open({
			panel: {
				id: `confluence-page-preview-panel-${title}`,
				content: () => <ConfluencePagePreviewPanel title={title} url={url} />,
			},
		});
	};

	const closeConfluencePagePreviewPanel = () => {
		const onClose = () => {};
		close(onClose);
	};

	return { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel };
};
